module.exports = __webpack_public_path__ + "static/media/about-placeholder.f627c02b.webp";